export enum DoubleBetPrevention {
    Disabled = 'Disabled',
    PreventIfSameOdds = 'PreventIfSameOdds',
}
